export default __webpack_public_path__ + "static/media/lemontbotanique_s2.10751ffd.png";